export class LoadingState {
  readonly isLoading: boolean;

  readonly isFailed: boolean;

  private constructor(isLoading: boolean, isFailed: boolean) {
    this.isLoading = isLoading;
    this.isFailed = isFailed;
  }

  public static loading(): LoadingState {
    return new LoadingState(true, false);
  }

  public static loadedWithError(): LoadingState {
    return new LoadingState(false, true);
  }

  public static loaded(): LoadingState {
    return new LoadingState(false, false);
  }
}
